import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./topBar.css";
import { decodeHtml } from "../../util";
const TopHeader = () => {
  const { page } = useSelector((state) => state.data);
  const [htmlContent, setHtmlContent] = useState(null);

  useEffect(() => {
    if (page && page.data && page.data["top-contact-bar"]) {
      const topContactBar = page.data["top-contact-bar"];

      if (topContactBar.siteId === 2 && topContactBar.htmlContent) {
        const decodedHtml = decodeHtml(topContactBar.htmlContent);
        // const cleanedHtml = decodedHtml.replace(/<\/?p[^>]*>/g, "");
        setHtmlContent(decodedHtml);
      }
    }
  }, [page]);

  return (
    <div className="topbar-area hidden-md" id="extraP">
      {/* <div class="container">
        <div class="row">
          <div class="col-lg-2">
            <div class="logo-part">
              <a href="/">
                <img src={logo} alt="Logo" />
              </a>
            </div>
          </div>
          <div class="col-lg-10 text-right">
            <ul class="rs-contact-info">
              <li class="contact-part">
                <i class="flaticon-email"></i>
                <span class="contact-info">
                  <span>E-mail</span>
                  <a
                    href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=info@techniajz.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    info@techniajz.com
                  </a>
                </span>
              </li>
              <li class="contact-part">
                <i class="flaticon-call"></i>
                <span class="contact-info">
                  <span>Phone</span>
                  <a href="tel:+919654652847">+91 9654652847</a>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div> */}
      {!htmlContent ? (
        ""
      ) : (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      )}
    </div>
  );
};

export default TopHeader;
